import { render, staticRenderFns } from "./AllBanks.vue?vue&type=template&id=33d8080e&"
import script from "./AllBanks.vue?vue&type=script&lang=js&"
export * from "./AllBanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports